import { render, staticRenderFns } from "./StartupsTimeline.vue?vue&type=template&id=bf8373e0&scoped=true&"
import script from "./StartupsTimeline.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsTimeline.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8373e0",
  null
  
)

export default component.exports